const uniqueSorted = (values) => Array.from(new Set(values)).sort((a, b) => a - b);

export const buildSnapGuides = (elements, selectedIds, artboardWidth, artboardHeight) => {
  const guidesX = [0, artboardWidth / 2, artboardWidth];
  const guidesY = [0, artboardHeight / 2, artboardHeight];

  elements
    .filter((el) => !selectedIds.includes(el.id))
    .forEach((el) => {
      guidesX.push(el.x, el.x + el.w / 2, el.x + el.w);
      guidesY.push(el.y, el.y + el.h / 2, el.y + el.h);
    });

  return {
    x: uniqueSorted(guidesX),
    y: uniqueSorted(guidesY),
  };
};

export const getSnapDelta = (bounds, guides, threshold) => {
  const candidatesX = [bounds.x, bounds.x + bounds.w / 2, bounds.x + bounds.w];
  const candidatesY = [bounds.y, bounds.y + bounds.h / 2, bounds.y + bounds.h];
  let bestDx = null;
  let bestGuideX = null;
  let bestDy = null;
  let bestGuideY = null;

  candidatesX.forEach((candidate) => {
    guides.x.forEach((guide) => {
      const diff = guide - candidate;
      const abs = Math.abs(diff);
      if (abs <= threshold && (bestDx === null || abs < Math.abs(bestDx))) {
        bestDx = diff;
        bestGuideX = guide;
      }
    });
  });

  candidatesY.forEach((candidate) => {
    guides.y.forEach((guide) => {
      const diff = guide - candidate;
      const abs = Math.abs(diff);
      if (abs <= threshold && (bestDy === null || abs < Math.abs(bestDy))) {
        bestDy = diff;
        bestGuideY = guide;
      }
    });
  });

  return {
    dx: bestDx || 0,
    dy: bestDy || 0,
    guideX: bestGuideX,
    guideY: bestGuideY,
  };
};
